import {ChangeDetectorRef, Component} from "@angular/core";
import {AbstractEditPage, PageContentMode} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {OrderReadyDisplayEntityModel} from "../order-ready-display-entity.model";
import {MetaTagType} from "../../../catalogue/meta-tag/meta-tag.data";

@Component({
    selector: "wbo-order-ready-display-edit-page",
    styleUrls: ["./order-ready-display-edit-page.component.scss"],
    templateUrl: "./order-ready-display-edit-page.component.html",
    providers: [
        provideEntityModel(OrderReadyDisplayEntityModel)
    ]
})
export class OrderReadyDisplayEditPageComponent extends AbstractEditPage {

    MetaTagType = MetaTagType;

    constructor(public model: OrderReadyDisplayEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
        this.pageState.contentMode = PageContentMode.DETAILED;
    }

    changeSite(): void {
        this.model.data.webTerminalIds = [];
    }

    outletsChanged(): void {
        if (this.model.data.outletIds.length) {
            this.model.data.terminalIds = [];
            this.model.data.webTerminalIds = [];
        }
    }

    terminalsChanged(): void {
        if (this.model.data.terminalIds.length) {
            this.model.data.outletIds = [];
            this.model.data.webTerminalIds = [];
        }
    }

    webTerminalsChanged(): void {
        if (this.model.data.webTerminalIds.length) {
            this.model.data.outletIds = [];
            this.model.data.terminalIds = [];
        }
    }
}
